import * as React from 'react';

import TeacherPremium from '../../Teacher/containers/TeacherPremium';

const TeacherPremiumApp = (props) => (
  <TeacherPremium {...props} />
);

export default TeacherPremiumApp
